import { render, staticRenderFns } from "./CardResume.vue?vue&type=template&id=755f5bea&scoped=true&"
import script from "./CardResume.vue?vue&type=script&lang=js&"
export * from "./CardResume.vue?vue&type=script&lang=js&"
import style0 from "./CardResume.vue?vue&type=style&index=0&id=755f5bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f5bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VCard,VDivider,VIcon,VProgressLinear})
